import React from 'react'

import Base from '../_Base'

const Premium16 = (props) => (
  <Base width="16" height="16" viewBox="0 0 16 16" aria-hidden='true' {...props}>
    <path
      d="M2.419 13 0 4.797 4.837 6.94 8 2l3.163 4.94L16 4.798 13.581 13z"
      fillRule="evenodd"
    />
  </Base>
)

export default Premium16
